import { Component } from "react";
import { BRAND_LOGO } from "../../lib/brand";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info);
  }

  reset = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center p-6" data-testid="app-error-boundary">
        <div className="tsc-card max-w-md w-full p-8 text-center">
          <img src={BRAND_LOGO} alt="" className="h-14 w-14 mx-auto rounded-full ring-1 ring-[#D4AF37]/40" />
          <p className="text-[10px] tracking-luxe uppercase text-[#D4AF37] mt-5">Something went wrong</p>
          <p className="font-display text-2xl text-white mt-2">We hit a snag.</p>
          <p className="text-white/55 text-sm mt-3">
            Please refresh to try again. If this keeps happening, contact support and we&apos;ll sort it for you.
          </p>
          {this.state.error?.message && (
            <p className="font-mono text-xs text-red-300/80 bg-black/40 border border-red-500/20 rounded p-3 mt-4 break-all text-left">
              {this.state.error.message}
            </p>
          )}
          <div className="flex items-center justify-center gap-3 mt-6">
            <button onClick={this.reset} className="tsc-btn-gold" data-testid="error-boundary-reload">Reload</button>
            <a href="/" className="tsc-btn-outline" data-testid="error-boundary-home">Go home</a>
          </div>
        </div>
      </div>
    );
  }
}
